export var getCreateGoalURL = function getCreateGoalURL(_ref) {
  var _ref$gatewayBaseUrl = _ref.gatewayBaseUrl,
    gatewayBaseUrl = _ref$gatewayBaseUrl === void 0 ? '' : _ref$gatewayBaseUrl;
  return "".concat(gatewayBaseUrl, "/gateway/api/graphql?operationName=CreateGoal");
};
export var getCreateGoalGraphqlPayload = function getCreateGoalGraphqlPayload(_ref2) {
  var name = _ref2.name,
    cloudId = _ref2.cloudId,
    ownerId = _ref2.ownerId,
    goalTypeAri = _ref2.goalTypeAri,
    targetDate = _ref2.targetDate,
    parentGoalAri = _ref2.parentGoalAri;
  return JSON.stringify({
    query: "mutation CreateGoal {\n\t\ttownsquare {\n\t\t\tcreateGoal(\n\t\t\t\tinput: {\n\t\t\t\t\tname: \"".concat(name, "\"\n\t\t\t\t\tcontainerId: \"ari:cloud:identity::site/").concat(cloudId, "\"\n\t\t\t\t\towner: \"ari:cloud:identity::user/").concat(ownerId, "\"\n\t\t\t\t\t").concat(goalTypeAri ? "goalTypeAri: \"".concat(goalTypeAri, "\"") : '', "\n\t\t\t\t\t").concat(targetDate, "\n\t\t\t\t\t").concat(parentGoalAri ? "parentGoalAri: \"".concat(parentGoalAri, "\"") : '', "\n\t\t\t\t}\n\t\t\t) @optIn(to: \"Townsquare\") {\n\t\t\t\tgoal {\n\t\t\t\t\tid\n\t\t\t\t\tkey\n\t\t\t\t\tname\n\t\t\t\t\turl\n\t\t\t\t\ticonData\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}"),
    operationName: 'CreateGoal'
  });
};
export var getDefaultAtlasBaseURL = function getDefaultAtlasBaseURL(subdomainName) {
  var hostname = window.location.hostname;
  var subdomain = subdomainName ? subdomainName : 'team';
  if (hostname.includes('jira-dev.com') || hostname.includes('.stg.atlassian.') || hostname.startsWith('localhost')) {
    return "https://".concat(subdomain, ".stg.atlassian.com");
  }
  return "https://".concat(subdomain, ".atlassian.com");
};